import { mall_set_store } from "@/util/store";

const order = {
    state: {
        orderInfo: {},
    },

    actions: {
        actions_createOrderInfo({ commit }, orderInfo) {
            budo_log.debug("#10 actions_createOrderInfo", orderInfo)

            return new Promise(((resolve, reject) => {
                commit('mutations_CREATE_ORDER_INFO', orderInfo)
                resolve()
            }));
        },

        actions_updateOrderInfo({ commit }, orderInfo) {
            budo_log.debug("#19 actions_updateOrderInfo", orderInfo)

            return new Promise(((resolve, reject) => {
                commit('mutations_UPDATE_ORDER_INFO', orderInfo)
                resolve()
            }));
        }
    },

    mutations: {
        mutations_CREATE_ORDER_INFO: (state, orderInfo) => {
            budo_log.debug("#30 mutations_CREATE_ORDER_INFO", orderInfo)

            state.orderInfo = orderInfo

            mall_set_store({
                name: 'order_info',
                content: state.orderInfo,
                type: 'session'
            })
        },

        mutations_UPDATE_ORDER_INFO: (state, orderInfo) => {
            budo_log.debug("#41 mutations_UPDATE_ORDER_INFO", orderInfo)

            const result = {}
            Object.assign(result, state.orderInfo, orderInfo)

            state.orderInfo = result;

            mall_set_store({
                name: 'order_info',
                content: state.orderInfo,
                type: 'session'
            })
        }
    }
}

export default order
